import { v4 as uuidv4 } from 'uuid';

import { convertSecondsToTimeFormat } from '@/pages/aigc/pages/Agent/ChatPage/utils';

type TThinkRawItem = {
  type?: string;
  thinkId?: string;
  inputIndex?: number;
  [key: string]: unknown;
};

/** agent 模式 think 子项预处理（流式 / 历史回放后统一走此逻辑） */
export const normalizeAgentThinkItems = (
  value: TThinkRawItem[] | undefined,
  thinkTimeSeconds?: number | string,
): { dataSource: TThinkRawItem[]; thinkTime: string; } => {
  const thinkTime = convertSecondsToTimeFormat(String(thinkTimeSeconds || ''));
  try {
    const res = (value || []).filter(
      task =>
        task.type !== 'plan_json' &&
        task.type !== 'current_token_total' &&
        task.type !== 'think_fold_mode',
    );
    if (!res.length) {
      return { dataSource: [], thinkTime };
    }

    if (res.some(item => !item.thinkId)) {
      let currentGroupId = '';
      let inputIndexCounter = 0;
      const processedRes = res.map(item => {
        if (item.type === 'switch_agent') {
          currentGroupId = uuidv4();
          return {
            ...item,
            thinkId: currentGroupId,
            inputIndex: item.inputIndex ?? (inputIndexCounter += 1),
          };
        }
        return item.thinkId ? item : { ...item, thinkId: currentGroupId };
      });
      return { dataSource: processedRes, thinkTime };
    }

    const switchAgentItems = res.filter(item => item.type === 'switch_agent');
    const hasSharedThinkId =
      switchAgentItems.length > 1 &&
      switchAgentItems.every(item => item.thinkId === switchAgentItems[0]?.thinkId);

    if (hasSharedThinkId) {
      let currentGroupId = '';
      let inputIndexCounter = 0;
      const processedRes = res.map(item => {
        if (item.type === 'switch_agent') {
          currentGroupId = uuidv4();
          return {
            ...item,
            thinkId: currentGroupId,
            inputIndex: item.inputIndex ?? (inputIndexCounter += 1),
          };
        }
        return { ...item, thinkId: currentGroupId };
      });
      return { dataSource: processedRes, thinkTime };
    }

    let inputIndexCounter = 0;
    const groupedMap = res.reduce((map: Map<string, TThinkRawItem[]>, item) => {
      const groupKey = String(item?.thinkId);
      const existingGroup = map.get(groupKey) || [];
      const normalizedItem =
        item.type === 'switch_agent'
          ? { ...item, inputIndex: item.inputIndex ?? (inputIndexCounter += 1) }
          : item;
      const newGroup =
        normalizedItem.type === 'switch_agent'
          ? [normalizedItem, ...existingGroup]
          : [...existingGroup, normalizedItem];
      return map.set(groupKey, newGroup);
    }, new Map<string, TThinkRawItem[]>());

    return {
      dataSource: Array.from(groupedMap).flatMap(([, items]) => items),
      thinkTime,
    };
  } catch (error) {
    console.error(error);
    return { dataSource: [], thinkTime: '' };
  }
};
